'use client';

import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import type { Simplify } from '../../../../prismicio-types';
import { CareerCards } from './CareerCards/CareerCards';
import { useVisible } from '@/hooks';

import styles from './careersInner.module.scss';

interface CareersInnerProps {
  data: Simplify<Content.CareersSliceDefaultPrimary>;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

export const CareersInner = ({ data }: CareersInnerProps) => {
  const [isVisible, id] = useVisible();

  return (
    <div className={styles.wrapper} id={id}>
      <CareerCards data={data} isVisible={isVisible} />
      <article
        className={`${styles.text_content} ${isVisible ? styles.isVisible : ''}`}
      >
        <div className={styles.title_wrapper}>
          <PrismicRichText field={data.title} components={components} />
        </div>
        <p className={styles.subtitle}>{data.subtitle}</p>
      </article>
    </div>
  );
};
